import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/App.css';
// Tailwind + the AiventraLMS look; must load after App.css so it wins.
import './styles/theme.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
